export const BROADCAST_TYPE = 'broadcastType';
